function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-clip"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "currentColor",
  d: "M25.000,49.000 C11.745,49.000 1.000,38.255 1.000,25.000 C1.000,11.745 11.745,1.000 25.000,1.000 C38.255,1.000 49.000,11.745 49.000,25.000 C49.000,38.255 38.255,49.000 25.000,49.000 ZM25.000,3.000 C12.850,3.000 3.000,12.850 3.000,25.000 C3.000,37.150 12.850,47.000 25.000,47.000 C37.150,47.000 47.000,37.150 47.000,25.000 C47.000,12.850 37.150,3.000 25.000,3.000 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.933,35.528c-0.146-1.612-0.09-2.737-0.09-4.21c0.73-0.383,2.038-2.825,2.259-4.888c0.574-0.047,1.479-0.607,1.744-2.818  c0.143-1.187-0.425-1.855-0.771-2.065c0.934-2.809,2.874-11.499-3.588-12.397c-0.665-1.168-2.368-1.759-4.581-1.759  c-8.854,0.163-9.922,6.686-7.981,14.156c-0.345,0.21-0.913,0.878-0.771,2.065c0.266,2.211,1.17,2.771,1.744,2.818  c0.22,2.062,1.58,4.505,2.312,4.888c0,1.473,0.055,2.598-0.091,4.21c-1.261,3.39-7.737,3.655-11.473,6.924  c3.906,3.933,10.236,6.746,16.916,6.746s14.532-5.274,15.839-6.713C37.688,39.186,31.197,38.93,29.933,35.528z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-gradient",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 1
})), /*#__PURE__*/React.createElement("mask", {
  id: "avatar-mask"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  height: 15,
  width: "100%",
  fill: "url(#avatar-gradient)"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "currentColor",
  d: "M25.000,49.000 C11.745,49.000 1.000,38.255 1.000,25.000 C1.000,11.745 11.745,1.000 25.000,1.000 C38.255,1.000 49.000,11.745 49.000,25.000 C49.000,38.255 38.255,49.000 25.000,49.000 ZM25.000,3.000 C12.850,3.000 3.000,12.850 3.000,25.000 C3.000,37.150 12.850,47.000 25.000,47.000 C37.150,47.000 47.000,37.150 47.000,25.000 C47.000,12.850 37.150,3.000 25.000,3.000 Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.933,35.528c-0.146-1.612-0.09-2.737-0.09-4.21c0.73-0.383,2.038-2.825,2.259-4.888c0.574-0.047,1.479-0.607,1.744-2.818  c0.143-1.187-0.425-1.855-0.771-2.065c0.934-2.809,2.874-11.499-3.588-12.397c-0.665-1.168-2.368-1.759-4.581-1.759  c-8.854,0.163-9.922,6.686-7.981,14.156c-0.345,0.21-0.913,0.878-0.771,2.065c0.266,2.211,1.17,2.771,1.744,2.818  c0.22,2.062,1.58,4.505,2.312,4.888c0,1.473,0.055,2.598-0.091,4.21c-1.261,3.39-7.737,3.655-11.473,6.924  c3.906,3.933,10.236,6.746,16.916,6.746s14.532-5.274,15.839-6.713C37.688,39.186,31.197,38.93,29.933,35.528z"
});

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar-clip)"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("rect", {
    mask: "url(#avatar-mask)",
    className: "loader",
    width: "100%",
    height: 15,
    y: 0,
    x: 0,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "red",
    style: {
      display: "none"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.376ff4b8.svg";
export { ForwardRef as ReactComponent };